import React, { useState,useEffect, useRef } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { NavLink } from "react-router-dom";
import { Link } from 'react-scroll'; // Ensure you import Link from 'react-scroll'
import ReachOutNow from "./ReachOut";
import "../App.css"
import "../styles/Events-Culture-shifts.css"
import "../styles/AboutUS.css"
import Footer from "../pages/footer";
import "../styles/OsakaEvent.css"

// Cards Import
import EventsCards from "./EventsCards";

const highlights = [
    {
      title: "World Assembly — Workshop 7: How the OSH Profession is Transforming",
      description: `
        <strong>Panel/Leaders:</strong> Dr. Marilyn Hubner (Chair/Moderator), Dee Arp (INSHPO), 
        Dr. Waddah S. Ghanem Al Hashmi (UAE Federal Committee for OHS), 
        Amiirah Peerbaccus (IOSHM), Stuart Hughes (Mercedes-AMG Petronas / former IOSH President), 
        Francesco Santi (ENSHPO).<br/><br/>
         Presentation and dialogue by Lisa McGuire (CEO/FOUNDER, GalaxyEDGE Safety Inc.) 
        delivered the case study "Lessons Learned from BC’s Manufacturing Sector" (competency framework results 
        and recommendations) alongside global practitioners on future skills, multi-disciplinary practice, and tech-enabled prevention.
      `,
      image: "/assets/GLBAL_OSH_Leaders Roundtable.jpg",
    },
    {
      title: "World Assembly — Workshop 2: The Future of Work & Workplaces",
      description: `
        <strong>Program highlights:</strong> Strategic tech talks (e.g., Rainer Binder, ACCENTURE), 
        on-stage demos (OSH immersive training by Winson Yeung, DGUV-IFA smart table saw), and an expert panel 
        (Jennifer Papantuono, Rainer Binder, Jakob Kort, Winson Yeung, Terence Lui, Mona Mustafa).<br/><br/>
         Lisa McGuire showcased Immersive Learning Tech in Health & Safety within the Tech Showcase.
      `,
      image: "/assets/Workshop2.jpg",
    },
    {
      title: "International Symposium (Practice Track, with ISSA)",
      description: `
        <strong>Program Highlights:</strong> International Symposium – Practice Track <br/>
        “Navigating Workplace Safety in the Digital Age” Co-Chairs Andrea Weimar (ISSA Section Machine & System Safety) 
        and Jennifer Papantuono (ISSA Section for Electricity, Gas & Water).<br/><br/>
        Talks:<br/>
        - Enhanced Workplace Safety with Smart Manufacturing – Otto Görnemann (SICK AG).<br/>
        - Navigating Safety in the Digital Age: Immersive Solutions for a Safer Future – Lisa McGuire (GESI) & Harrison Olajos (UP360).<br/>
        - Industrial Security, Global Responsibility – Jonas Stein (DGUV-IFA).<br/><br/>
        <strong>Roundtable (Moderator: Lisa McGuire):</strong> Görnemann, Olajos, Stein.
      `,
      image: "/assets/ISSA_GESI_SymposiumGISHW2.jpg",
    },
    {
      title: "World Assembly launches at Expo 2025 to advance safer, healthier work",
      description: `
        A landmark Founding Declaration was signed in Osaka–Kansai as part of Expo 2025, launching the World Assembly of Occupational Safety, Health and Well-being Professionals and Stakeholders. Convened during the four-day GISHW “Days on Safety, Health and Well-being” program—the first time in 170+ years that OSH has featured at a World Expo—the Assembly unites global leaders to accelerate safer, healthier and more sustainable workplaces.<br/><br/>
       The Declaration sets a shared agenda through 2030, recognizing that safe, healthy, fair and future-ready work is essential to thriving societies, especially amid geopolitical volatility, digital transformation, climate change and demographic shifts <br/><br/>
       <strong>What the Declaration commits to:</strong><br/>
       - Promote safety & well-being through proactive risk management, inclusive design and ethical technology<br/>
       - Drive global collaboration to share expertise across borders—especially on digitalization, climate and demographic change<br/>
       - Empower future leaders by ensuring diverse perspectives and fostering innovation in the OSH profession<br/>
       - Create a shared 2030 Roadmap that turns commitments into measurable actions informed by Expo 2025 workshops <br/><br/>
       The Assembly will serve as a continuing platform for dialogue, shared learning and leadership, with collective progress expected to be revisited at GISHW Days in Riyadh in 2030. Organizations and stakeholders interested in partnering are invited to join this global effort
      `,
      images: [
        "/assets/Osaka1.JPG",
        // "/assets/Osaka3.JPG",
        // "/assets/Osaka4.JPG"
      ]
    
    },
  ];
  


const slides = [
  { 
    img: "/assets/Leadership.jpg", 
    text: "GISHW @ EXPO 2025 Osaka–Kansai",
    // cta: { label: "See Highlights", url: "/contact" }
  },
  { 
    img: "/assets/Osaka1.JPG", 
    text: "GESI Signing Decleration",
    // cta: { label: "Register now", url: "/contact" }
  },
  { 
    img: "/assets/GISHWEvent.jpg", 
    text: "Closing Bridge Dance",
    // cta: { label: "Read News", url: "/news" }
  },
  { 
    img: "/assets/GLBAL_OSH_Leaders Roundtable.jpg", 
    text: "Leaders Roundtable",
    // cta: { label: "See Highlights", url: "/highlights" }
  },
  { 
    img: "/assets/HH_ISSA_DGUV_GESI_2.jpg", 
    // text: "Partner Spotlights & Roundtables",
    // cta: { label: "Partner With Us", url: "/partnerships" }
  }
];


const cards = [
  {
    title: "Book a Speaking Engagement ",
    img: "/assets/Events1.jpg",
    subtitle: "Invite us to attend your conference, leadership forum or in-house event",
    info1: [
    //   "Stay ahead of the curve with interactive webinars focused on safety strategy, ESG alignment, AI innovation, and more"
    ],    
  },
  {
    title: "Upcoming Events",
    img: "/assets/Events2.jpg",
    subtitle: "Stay ahead of the curve with interactive webinars focused on safety strategy, ESG alignment, AI innovation, and more.",
    info1: [
      "COMING SOON"
    ],    
  },
  {
    title: "What is in the news at GESI",
    img: "/assets/Events3.jpg",
    subtitle: "Browse the inventory on past events or read the latest news and initiatives we are working on…",
    info1: [
      "COMING SOON"
    ],    
  }
]
export default function OsakaEvent() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Scroll handler (optional, if used by a button)
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);

  // Slideshow state
  const [slideIndex, setSlideIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const timeoutRef = useRef(null);
  const SLIDE_MS = 4000;

    // auto-advance
    useEffect(() => {
      if (paused) return;
      timeoutRef.current = setTimeout(() => {
        setSlideIndex((i) => (i + 1) % slides.length);
      }, SLIDE_MS);
      return () => clearTimeout(timeoutRef.current);
    }, [slideIndex, paused]);


  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setVisible(true), 500);
          obs.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  // Open/close a card’s detail
  const openCard = (i) => {
    setExpandedIndex((prev) => (prev === i ? null : i));
  };

  // If a card is expanded, fetch its detail1/info1/image1
  const current = expandedIndex !== null ? cards[expandedIndex] : null;


  return (
    
    <div className = "OsakaEvent-container">
      <ReachOutNow/>

      

      <div className = "EventsCultureShifts-Page-container">
        <div className = "EventsCultureShifts-main-heading">
            <h1>
            GISHW @ EXPO 2025 Osaka–Kansai (16-19 July 2025)
            
            </h1>
        </div>

              {/* === SLIDESHOW === */}
      <div
          ref={sectionRef}
          className="events-slideshow"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          <div
            className="events-slides-track"
            style={{ transform: `translateX(-${slideIndex * 100}%)` }}
          >
            {slides.map((s, i) => (
              <div className="events-slide" key={i}>
                <img src={s.img} alt={s.text} className="events-slide-img" />
                <div className="events-slide-topright">
                  <span className="events-slide-pill">{s.text}</span>
                </div>
                <div className="events-slide-gradient" />
              </div>
            ))}
          </div>

          {/* Apple-like dots */}
          <div className="events-dots">
            {slides.map((_, i) => (
              <button
                key={i}
                className={`events-dot ${i === slideIndex ? "active" : ""}`}
                onClick={() => setSlideIndex(i)}
              />
            ))}
          </div>

            {/* Pause/Play button */}
            <button
              className="events-toggle"
              aria-label={paused ? "Play slideshow" : "Pause slideshow"}
              onClick={() => setPaused((p) => !p)}
            >
              {paused ? "▶︎" : "❚❚"}
            </button>

            {/* Per-slide CTA (bottom-right) */}
              {slides[slideIndex]?.cta && (
                <NavLink
                  to={slides[slideIndex].cta.url}
                  className="events-quicklink"
                  aria-label={slides[slideIndex].cta.label}
                >
                  {slides[slideIndex].cta.label}
                </NavLink>
              )}


          
        </div>

        <div className="section-header">
        <br />
          <p>
          The Global Initiative for Safety, Health, and Well-being (GISHW) is a world-first effort to place worker safety, health, and wellbeing at the heart of a sustainable future. Guided by the UN SDGs, the ILO’s Fundamental Principles and Rights at Work, and the ISSA Vision Zero mindset, GISHW is championed by international visionaries Hans-Horst Konkolewsky (International ORP Foundation) and Dr. Toshihiro Fujita (IGSAP).
          <br />
          <br />
          Born from the momentum of the Vision Zero Summit Japan (2022), GISHW convened leading organizations and experts to co-create a multi-program platform at EXPO 2025—uniting a Summit, World Assembly, International Symposium, Youth Congress, Exhibition, Festival, and Standardization Forum. The mission is simple and ambitious: when workplaces prioritize safety, health, and psychological wellbeing, societies thrive.
          </p>
        </div>

        <div className="highlights-container">
      <h2 className="highlights-heading">Event Highlights</h2>
        {highlights.map((item, idx) => (
            <div
                key={idx}
                className={`highlight-row ${idx % 2 === 1 ? "reverse" : ""}`}
            >
                <div className="highlight-image">
                {item.images ? (
                    item.images.map((src, i) => (
                    <img key={i} src={src} alt={`${item.title} ${i + 1}`} />
                    ))
                ) : (
                    <img src={item.image} alt={item.title} />
                )}
                </div>
                <div
                className="highlight-text"
                dangerouslySetInnerHTML={{
                    __html: `<h3>${item.title}</h3>${item.description}`,
                }}
                />
            </div>
            ))}

    </div>
   </div>
        <Footer/> 
    </div>
  );
}